import { createContext, useContext } from 'react';

/**
 * Lets any part of the marketing site open the closed-beta dialog.
 *
 * The dialog itself lives in `SiteChrome` so there is exactly one of them, but
 * both the header and the hero need to open it. A context beats threading a
 * callback through every page.
 *
 * The default is a no-op rather than a throw: the pages are rendered outside
 * `SiteChrome` in tests and in the build-time prerender, and neither should
 * fail because nothing is listening.
 */
export const RegisterDialogContext = createContext<{ openRegisterDialog: () => void }>({
  openRegisterDialog: () => {},
});

export function useRegisterDialog(): { openRegisterDialog: () => void } {
  return useContext(RegisterDialogContext);
}
